import { render, staticRenderFns } from "./galleryHome.vue?vue&type=template&id=5498c908&scoped=true"
import script from "./galleryHome.vue?vue&type=script&lang=js"
export * from "./galleryHome.vue?vue&type=script&lang=js"
import style0 from "./galleryHome.vue?vue&type=style&index=0&id=5498c908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5498c908",
  null
  
)

export default component.exports